<template>
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="page-header min-vh-75">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-6 d-flex flex-column">
              <div class="mt-8 card card-plain">
                <div class="pb-0 card-header text-start">
                  <h2 class="font-weight-bolder mb-6">
                    {{ $t("global.appTitle") }}
                  </h2>
                  <h3 class="font-weight-bolder text-success text-gradient">
                    {{ $t("login.welcomeMessage") }}
                  </h3>
                  <p class="mb-0">
                    {{ $t("login.enterCredentials") }}
                  </p>
                </div>
                <div class="card-body">
                  <form @submit.prevent="login" class="text-start">
                    <label>Email</label>
                    <input
                      v-model="email"
                      id="email"
                      type="email"
                      name="email"
                      autocomplete="'nope'"
                      placeholder="Email"
                      class="form-control form-group"
                    />
                    <label>{{ $t("login.password") }}</label>
                    <input
                      v-model="password"
                      id="password"
                      type="password"
                      name="password"
                      autocomplete="'new-password'"
                      :placeholder="$t('login.password')"
                      class="form-control form-group"
                    />
                    <!-- <soft-switch id="rememberMe" name="rememberMe">
                      {{ $t("login.rememberMe") }}
                    </soft-switch> -->
                    <div class="text-center">
                      <soft-button
                        type="submit"
                        class="my-4 mb-2"
                        variant="gradient"
                        color="success"
                        full-width
                        >{{ $t("login.signIn") }}
                      </soft-button>
                    </div>
                  </form>
                </div>
                <!-- <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    Don't have an account?
                    <router-link
                      :to="{ name: 'Sign Up' }"
                      class="text-success text-gradient font-weight-bold"
                      >Sign up</router-link
                    >
                  </p>
                </div> -->
              </div>
            </div>
            <div class="col-md-6">
              <div
                class="top-0 oblique position-absolute h-100 d-md-block d-none me-n8"
              >
                <div
                  class="bg-cover oblique-image position-absolute fixed-top ms-auto h-100 z-index-0 ms-n6"
                  :style="{
                    backgroundImage:
                      'url(' +
                      require('@/assets/img/curved-images/financial-assistance2.png') +
                      ')',
                  }"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <app-footer />
</template>

<script>
import AppFooter from "@/examples/PageLayout/Footer.vue";
// import SoftSwitch from "@/components/SoftSwitch.vue";
import SoftButton from "@/components/SoftButton.vue";
const body = document.getElementsByTagName("body")[0];
import { mapMutations } from "vuex";
import axios from "axios";
import swal from "sweetalert2";
import router from "../router";

export default {
  name: "SignIn",
  components: {
    AppFooter,
    // SoftSwitch,
    SoftButton,
  },
  data() {
    return {
      email: "",
      password: "",
    };
  },
  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
  },
  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),

    async login() {
      try {
        let res = await axios.post("login", {
          email: this.email,
          password: this.password,
        });
        const responseData = res.data;
        localStorage.setItem("token", responseData.token);
        localStorage.setItem("userRole", responseData.user.roles[0].name);
        //localStorage.setItem("season", responseData.season);
        this.$store.dispatch("updateSeason", responseData.season);

        router.push("/dashboard");
      } catch (err) {
        this.email = "";
        this.password = "";
        swal.fire({
          icon: "error",
          title: this.$t(err.response.data.message),
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
  },
};
</script>
